var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-show-layout',[_c('va-show',{attrs:{"item":_vm.item}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"sm":"6"}},[_c('base-material-card',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_c('div',{staticClass:"display-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]},proxy:true}])},[_c('v-card-text')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }